/// <reference types="grecaptcha" />
declare global {
  interface Window {
    recaptchaOnLoadCallback: () => void
  }
}

export const useRecaptcha = sharedComposable(() => {
  let readyPromise = Promise.resolve()

  const { functionalCookieConsentScriptTrigger, functionalCookiesAccepted } = useCookieConsent()

  return useScript(
    {
      src: 'https://www.google.com/recaptcha/api.js?onload=recaptchaOnLoadCallback&render=explicit',
      async: true,
      crossorigin: false,
    },
    {
      beforeInit() {
        if (import.meta.client) {
          readyPromise = new Promise((resolve) => {
            window.recaptchaOnLoadCallback = resolve
          })
        }
      },
      use() {
        const wrapFn = <K extends keyof ReCaptchaV2.ReCaptcha>(key: K) => {
          return (...args: Parameters<ReCaptchaV2.ReCaptcha[K]>) => {
            if (import.meta.client) {
              // https://stackoverflow.com/a/77881726
              readyPromise.then(() => (window.grecaptcha as { [P in keyof ReCaptchaV2.ReCaptcha]: (...args: Parameters<ReCaptchaV2.ReCaptcha[P]>) => void })[key](...args))
            }
          }
        }

        return {
          render: wrapFn('render'),
          execute: wrapFn('execute'),
          reset: wrapFn('reset'),
          getResponse: wrapFn('getResponse'),
        }
      },
      trigger: functionalCookieConsentScriptTrigger,
      warmupStrategy: functionalCookiesAccepted.value ? 'preload' : false,
    }
  )
})
